import { render } from "./ServicesSection.vue?vue&type=template&id=0ae825c3&ts=true"
import script from "./ServicesSection.vue?vue&type=script&lang=ts"
export * from "./ServicesSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__